module.exports = __webpack_public_path__ + "static/media/news1.410ee239.webp";